import {
  LogOut,
  Settings,
  ShieldCheck,
  User,
} from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../features/session/sessionSlice";
import UserAvatar from "./UserAvatar";

function UserMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.session.user);
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleLogout = () => {
    closeMenu();
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  return (
    <div ref={menuRef} className="user-menu">
      <button
        aria-expanded={isOpen}
        aria-haspopup="menu"
        aria-label="Open profile menu"
        className="user-menu-trigger"
        type="button"
        onClick={() => setIsOpen((current) => !current)}
      >
        <UserAvatar name={user.name} status={user.status} />
      </button>

      {isOpen ? (
        <div className="user-menu-popover" role="menu">
          <div className="user-menu-summary">
            <UserAvatar className="is-large" name={user.name} status={user.status} />
            <div className="user-menu-copy">
              <p className="user-menu-name">{user.name}</p>
              <p className="user-menu-role">
                <ShieldCheck size={14} />
                <span>{user.role}</span>
              </p>
              <p className="user-menu-email">{user.email}</p>
            </div>
          </div>

          <div className="user-menu-list">
            <Link className="user-menu-item" role="menuitem" to="/profile" onClick={closeMenu}>
              <User size={16} />
              <span>Profile</span>
            </Link>
            <Link className="user-menu-item" role="menuitem" to="/settings" onClick={closeMenu}>
              <Settings size={16} />
              <span>Account settings</span>
            </Link>
            <button className="user-menu-item danger" role="menuitem" type="button" onClick={handleLogout}>
              <LogOut size={16} />
              <span>Sign out</span>
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default UserMenu;
